import { Stack, IconButton, type SxProps, InputBase } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { useAppDispatch, useAppSelector } from '../../libs/redux/store';
import { setSearchState } from '../../libs/redux/appUiSlice';
import ClientSearch from './ClientSearch';
import MaterialSearch from './MaterialSearch';
import { useIntlTranslations } from '@libs/intl/intl.hooks';
import GoodsSearch from './GoodsSearch';
import { useAnalytics } from '@libs/mixpanel/useAnalytics';

type SearchBarProps = {
  sx?: SxProps;
};

const SearchBar = ({ sx }: SearchBarProps) => {
  const isSearchActive = useAppSelector(state => state.appUi.isSearchActive);
  const searchFilter = useAppSelector(state => state.appUi.searchFilter);
  const dispatch = useAppDispatch();
  const { t } = useIntlTranslations();
  const { trackEvent } = useAnalytics();

  return (
    <Stack
      onClick={() => {
        trackEvent('search_used', { search_type: searchFilter, has_query: isSearchActive });
        dispatch(setSearchState(!isSearchActive));
      }}
      direction="row"
      sx={{ flex: 85, bgcolor: '#140f1124', borderRadius: '10px', height: '2.8rem' }}
      justifyContent="space-between"
      alignItems="center"
    >
      <IconButton sx={{ ...sx, width: 48 }}>
        {isSearchActive ? (
          <SearchOffIcon sx={{ color: '#f0f0f0' }} />
        ) : (
          <SearchIcon sx={{ color: '#f0f0f0' }} />
        )}
      </IconButton>
      {!isSearchActive && (
        <InputBase placeholder={t('searchPlaceholder')} fullWidth sx={{ color: '#ffffff' }} />
      )}
      {isSearchActive && (
        <Stack flex={1} onClick={e => e.stopPropagation()}>
          {searchFilter === 'material' ? (
            <MaterialSearch />
          ) : searchFilter === 'goods' ? (
            <GoodsSearch />
          ) : (
            <ClientSearch />
          )}
        </Stack>
      )}
    </Stack>
  );
};

export default SearchBar;
